import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

interface Props {
  company?: { is_test_restaurant?: boolean } | null;
  className?: string;
}

/**
 * A partner's test restaurant takes real orders, so anyone landing on it must
 * see at a glance that it is not a real restaurant. Renders nothing otherwise.
 */
export default function TestRestaurantBadge({ company, className }: Props): JSX.Element | null {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Company:TestRestaurant' });

  if (!company?.is_test_restaurant) {
    return null;
  }

  return (
    <span
      data-test="test-restaurant-badge"
      title={t('badge_title')}
      className={classNames(
        'inline-flex shrink-0 items-center rounded-full bg-amber-100 px-xs py-[2px] text-xs font-semibold uppercase text-amber-800',
        className,
      )}
    >
      {t('badge')}
    </span>
  );
}
